import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "workflow-controls-wrapper" },
    [
      _c("div", { staticClass: "workflow-controls" }, [
        _c(
          "div",
          { staticClass: "d-flex workflow-buttons" },
          [
            _c(
              "tooltip",
              {
                attrs: {
                  value: _vm.engineButtonTooltipMsg,
                  position: "top-left",
                  disabled:
                    _vm.engineCanRun &&
                    !_vm.calculatingScenarioElasticityResults &&
                    !_vm.hasUnsavedKpiResults,
                },
              },
              [
                !_vm.isUnitManagerView
                  ? _c(
                      VBtn,
                      {
                        class: [
                          "refresh-button",
                          "mr-2",
                          `${
                            _vm.hasUnsavedKpiResults &&
                            !_vm.calculatingScenarioResults
                              ? "unsaved-kpis"
                              : ""
                          }`,
                        ],
                        attrs: {
                          depressed: "",
                          loading: _vm.calculatingScenarioResults,
                          disabled:
                            !_vm.isEditable ||
                            !_vm.engineCanRun ||
                            _vm.calculatingScenarioElasticityResults,
                          "data-dd-action-name": "Grid view recalculate all",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.recalculate()
                          },
                        },
                      },
                      [_c("cog-play-icon")],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "tooltip",
              {
                attrs: {
                  value: _vm.$t("gridView.tooltips.hasUnsavedKpiResults"),
                  position: "top-left",
                  disabled: !_vm.hasUnsavedKpiResults,
                },
              },
              [
                _vm.readFromDatabricks
                  ? _c(
                      VBtn,
                      {
                        class: [
                          "save-button",
                          "mr-2",
                          "pa-0",
                          `${_vm.hasUnsavedKpiResults ? "unsaved-kpis" : ""}`,
                        ],
                        attrs: {
                          outlined: "",
                          small: "",
                          depressed: "",
                          disabled: !_vm.hasUnsavedKpiResults,
                          loading: _vm.savingKpiResults,
                        },
                        on: { click: _vm.onSaveKpiResultsToDatabricks },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("gridView.saveChanges")) +
                            "\n        "
                        ),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        !_vm.isUnitManagerView
          ? _c(
              "div",
              { staticClass: "workflow-info-row" },
              [
                _c("last-triggered-info", {
                  attrs: {
                    "last-triggered-info": _vm.get(
                      _vm.lastTriggeredInfo.strategic_engine_full_run,
                      _vm.scenario,
                      {}
                    ),
                    loading: _vm.isLastTriggeredLoading.strategic_engine,
                    source: "strategic_engine_full_run",
                    width: 200,
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      !_vm.isUnitManagerView
        ? _c(
            "feature-toggle",
            { attrs: { toggle: _vm.enablePriceOptimisation } },
            [
              _c("div", { staticClass: "workflow-controls" }, [
                _c(
                  "div",
                  { staticClass: "d-flex workflow-buttons" },
                  [
                    _c(
                      "tooltip",
                      {
                        attrs: {
                          value: _vm.crossElasticityButtonTooltipMsg,
                          position: "top-left",
                          disabled:
                            !_vm.calculatingScenarioResults &&
                            !_vm.hasUnsavedKpiResults &&
                            _vm.hasAOExtracts,
                        },
                      },
                      [
                        _c(
                          VBtn,
                          {
                            class: [
                              "refresh-button",
                              "cross-elasticity-button",
                              "mr-2",
                            ],
                            attrs: {
                              depressed: "",
                              loading: _vm.calculatingScenarioElasticityResults,
                              disabled: !_vm.canRunOptimisation,
                              "data-dd-action-name":
                                "Grid view cross-elasticity run",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.runCrossElasticityOptimisation()
                              },
                            },
                          },
                          [_c("circles-play-icon")],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "workflow-info-row" },
                  [
                    _vm.hasAOExtracts
                      ? _c("last-triggered-info", {
                          attrs: {
                            "last-triggered-info": _vm.get(
                              _vm.lastTriggeredInfo.cross_elasticity_engine,
                              _vm.scenario,
                              {}
                            ),
                            loading:
                              _vm.isLastTriggeredLoading
                                .cross_elasticity_engine,
                            source: "cross_elasticity_engine",
                            "translation-time-key":
                              "gridView.optimisationLastRunTime",
                            width: 200,
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isUnitManagerView
        ? _c(
            "feature-toggle",
            { attrs: { toggle: _vm.allowBulkPriceOverrides } },
            [
              _c("div", { staticClass: "workflow-controls" }, [
                _c(
                  "div",
                  { staticClass: "d-flex workflow-buttons" },
                  [
                    _c(
                      "tooltip",
                      {
                        attrs: {
                          value: _vm.bulkActionsTooltip,
                          position: "top-left",
                          disabled: !_vm.isBulkActionsDisabled,
                        },
                      },
                      [
                        _c(
                          VMenu,
                          {
                            attrs: { "offset-y": "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function ({ on, attrs }) {
                                    return [
                                      _c(
                                        VBtn,
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticClass:
                                                "bulk-actions-button pa-0 mr-2",
                                              attrs: {
                                                outlined: "",
                                                small: "",
                                                disabled:
                                                  _vm.isBulkActionsDisabled,
                                                loading:
                                                  _vm.bulkSelectionState
                                                    .isLoading,
                                              },
                                            },
                                            "v-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _c(
                                            VIcon,
                                            {
                                              staticClass: "mr-1",
                                              attrs: { small: "" },
                                            },
                                            [_vm._v("mdi-menu-down")]
                                          ),
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$t(
                                                  "gridView.bulkActions.label"
                                                )
                                              ) +
                                              "\n                "
                                          ),
                                          _vm.bulkSelectionState.selectedCount >
                                          0
                                            ? _c(
                                                "span",
                                                { staticClass: "ml-1" },
                                                [
                                                  _vm._v(
                                                    "\n                  (" +
                                                      _vm._s(
                                                        _vm.bulkSelectionState
                                                          .selectedCount
                                                      ) +
                                                      ")\n                "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2833313123
                            ),
                          },
                          [
                            _vm._v(" "),
                            _c(
                              VList,
                              { attrs: { dense: "" } },
                              _vm._l(
                                _vm.bulkPriceOverrideMenuItems,
                                function (item) {
                                  return _c(
                                    VListItem,
                                    {
                                      key: item.action,
                                      on: {
                                        click: function ($event) {
                                          return _vm.onBulkPriceOverrideSelected(
                                            item.action
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(VListItemTitle, [
                                        _vm._v(_vm._s(_vm.$t(item.labelKey))),
                                      ]),
                                    ],
                                    1
                                  )
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }